import * as React from 'react'

import {
  i18n,
  useLoginCheck,
  useSiteDefinition,
} from '@thg-commerce/enterprise-core'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'

import { useProductPageSku } from '../../../context'
import {
  CreateReviewButton,
  NoReviewsParagraph,
  NoReviewsWrapper,
  NoReviewTitle,
} from '../TopProductReviews/styles'
import { generateAddReviewFormUrlWithReturnTo } from '../utils'

export const NoReviewsFound = () => {
  const sku = useProductPageSku()
  const isLoggedIn = useLoginCheck()
  const { originUrl } = useSiteDefinition()
  const theme = useTheme()
  const i18nText = {
    createReviewButton: i18n('reviews.createreview.text'),
    customerReviewsTitle: i18n('reviews.paginatedproductreviews.title'),
    noReviewFound: i18n('reviews.noreviews.text'),
    writeReview: i18n('reviews.writereview.text'),
  }

  return (
    <NoReviewsWrapper>
      <NoReviewTitle
        textStyle={theme.pageTheme.topProductReviews.noReviewTitle?.textStyle}
      >
        {i18nText.customerReviewsTitle}
      </NoReviewTitle>
      {i18nText.noReviewFound && (
        <NoReviewsParagraph>{i18nText.noReviewFound}</NoReviewsParagraph>
      )}
      {i18nText.writeReview && (
        <NoReviewsParagraph>{i18nText.writeReview}</NoReviewsParagraph>
      )}
      <CreateReviewButton
        emphasis={
          theme.pageTheme?.productRating.reviews?.createReviewCTA.emphasis ??
          'medium'
        }
        renderedAs="a"
        href={generateAddReviewFormUrlWithReturnTo(sku, originUrl, isLoggedIn)}
      >
        {i18nText.createReviewButton}
      </CreateReviewButton>
    </NoReviewsWrapper>
  )
}
